import {observer} from 'mobx-react-lite'
import React from 'react'
import {HeaderShadow} from '@components/common/base/table/header-shadow'
import {cn} from '@containers/html-utils'
import {TableHeadCell} from './table-head-cell'
import {TableHeadRow} from './table-head-row'
import {useTableStore} from './table-store'
import {TableColumn} from './types'
import {tableSortToState} from './utils'

interface TableHead {
  onTop: boolean
  stickyHeader: boolean
  withHeaderShadow?: boolean
  className?: string
  headClassNameWrapper?: string
  shadowType?: 'old' | 'sm'
}

export const TableHead = observer((props: TableHead) => {
  const {onTop, className, headClassNameWrapper, stickyHeader, shadowType} =
    props
  const [state, store] = useTableStore()

  const showShadow = state.showHeaderShadow
  const smShadow = shadowType === 'sm'
  const oldShadow = shadowType === 'old'

  return (
    <div
      className={`${cn(
        stickyHeader && 'sticky',
        headClassNameWrapper
      )} top-0 z-20 bg-primary`}
    >
      <TableHeadRow
        className={cn(className, showShadow && smShadow && 'shadow-sm')}
        onTop={onTop}
      >
        {store.currentColumns.map((column, i) => {
          return <HeadItem column={column} i={i} key={column.id} />
        })}
      </TableHeadRow>
      {showShadow && oldShadow && <HeaderShadow />}
    </div>
  )
})

const HeadItem = observer(
  <T,>({column, i}: {i: number; column: TableColumn<T>}) => {
    const [state, store] = useTableStore()

    return (
      <TableHeadCell
        className={column.className}
        width={column.width}
        minWidth={column.minWidth}
        maxWidth={column.maxWidth}
        onClick={column.sortBy ? () => store.setColumnSort(i) : undefined}
        sortState={column.sortBy ? tableSortToState(state.sort, i) : undefined}
        oldSortStyle={column.oldSortStyle}
        name={column.name}
        showTooltip={column.showTooltip}
      >
        {column.title}
      </TableHeadCell>
    )
  }
)
